// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const RulerIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M21 4H3a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V5a1 1 0 00-1-1zm-1 14H4V6h2v5a1 1 0 002 0V6h3v7a1 1 0 002 0V6h3v5a1 1 0 002 0V6h2z"/></svg>'} />;

RulerIcon.displayName = 'RulerIcon';

export default RulerIcon;
